(function() {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var page = document.getElementById('homepage-premium');
  if (!page) return;

  /* ═══════════════════════════════════════════════════════════════════════════
     REVEAL ANIMATIONS — IntersectionObserver
     ═══════════════════════════════════════════════════════════════════════════ */

  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    // Single elements reveal
    var revealElements = page.querySelectorAll('.hp-reveal');
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });

    // Stagger elements reveal
    var staggerElements = page.querySelectorAll('.hp-reveal-stagger');
    var staggerObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          staggerObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -30px 0px'
    });

    staggerElements.forEach(function(el) {
      staggerObserver.observe(el);
    });
  } else {
    // No animation: show everything immediately
    page.querySelectorAll('.hp-reveal, .hp-reveal-stagger').forEach(function(el) {
      el.classList.add('is-inview');
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     GUIDE OLFACTIF — Mobile Accordion (via toggle button) & Desktop Hover
     Structure a11y : button.hp-olfactif-toggle contrôle l'expansion
     ═══════════════════════════════════════════════════════════════════════════ */

  var olfactifGrid = page.querySelector('.hp-olfactif-grid');
  if (olfactifGrid) {
    var univers = olfactifGrid.querySelectorAll('.hp-olfactif-univers');
    var toggles = olfactifGrid.querySelectorAll('.hp-olfactif-toggle');
    var isMobile = window.innerWidth < 768;

    // Helper: reset all states
    function resetAllUniversStates() {
      univers.forEach(function(u) {
        u.classList.remove('is-expanded', 'is-active');
      });
      toggles.forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }

    // Handle window resize
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        isMobile = window.innerWidth < 768;
        resetAllUniversStates();
      }, 150);
    });

    // Mobile: toggle button controls expansion
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var card = toggle.closest('.hp-olfactif-univers');
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        // Close all other cards
        univers.forEach(function(u) {
          if (u !== card) {
            u.classList.remove('is-expanded');
            var otherToggle = u.querySelector('.hp-olfactif-toggle');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current card
        card.classList.toggle('is-expanded', !isExpanded);
        toggle.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
      });
    });

    // Desktop: hover handling (CSS handles flex expansion)
    univers.forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        if (isMobile) return;
        card.classList.add('is-active');
      });

      card.addEventListener('mouseleave', function() {
        if (isMobile) return;
        card.classList.remove('is-active');
      });

      // Desktop: focus on CTA link triggers active state
      var ctaLink = card.querySelector('.hp-olfactif-cta');
      if (ctaLink) {
        ctaLink.addEventListener('focus', function() {
          if (!isMobile) {
            card.classList.add('is-active');
          }
        });
        ctaLink.addEventListener('blur', function() {
          if (!isMobile) {
            card.classList.remove('is-active');
          }
        });
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     GAMME CAROUSEL — Hover states fallback (for browsers without :has() support)
     ═══════════════════════════════════════════════════════════════════════════ */

  var gammeCarousels = page.querySelectorAll('[data-gamme-carousel]');
  if (gammeCarousels.length > 0 && window.matchMedia('(hover: hover)').matches) {
    var supportsHas = CSS.supports('selector(:has(*))');

    // Only add JS handling if :has() is not supported
    if (!supportsHas) {
      gammeCarousels.forEach(function(carousel) {
        var items = carousel.querySelectorAll('.hp-gamme-item');

        items.forEach(function(item) {
          item.addEventListener('mouseenter', function() {
            carousel.classList.add('has-hover');
            item.classList.add('is-hovered');
          });

          item.addEventListener('mouseleave', function() {
            carousel.classList.remove('has-hover');
            item.classList.remove('is-hovered');
          });
        });
      });
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     INTERLUDE BOUGIE — Premium animation system
     - Flame trigger with delay
     - Mobile scrollytelling (2 beats)
     - Scroll hint hide
     ═══════════════════════════════════════════════════════════════════════════ */

  var interludeSection = page.querySelector('[data-interlude]');

  if (interludeSection && 'IntersectionObserver' in window) {
    var isMobileInterlude = window.innerWidth < 768;
    var scrollytellingEnabled = interludeSection.dataset.scrollytelling === 'true';
    var hasScrolled = false;

    // ─── Main Observer: Trigger is-lit on entry ───
    var interludeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Slight delay for dramatic effect
          setTimeout(function() {
            entry.target.classList.add('is-lit');
          }, 250);
          interludeObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.25,
      rootMargin: '0px 0px -15% 0px'
    });

    interludeObserver.observe(interludeSection);

    // ─── Mobile Scrollytelling: Beat 2 reveal ───
    if (isMobileInterlude && scrollytellingEnabled && !prefersReducedMotion) {
      var beat2Observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            interludeSection.dataset.step = '2';
            beat2Observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: [0.3, 0.5, 0.7],
        rootMargin: '0px 0px -20% 0px'
      });

      beat2Observer.observe(interludeSection);
    } else {
      // Desktop or reduced-motion: show all immediately
      interludeSection.dataset.step = '2';
    }

    // ─── Scroll Hint: Hide after first scroll ───
    var scrollHintHandler = function() {
      if (!hasScrolled) {
        hasScrolled = true;
        interludeSection.classList.add('is-scrolled');
        window.removeEventListener('scroll', scrollHintHandler);
      }
    };

    // Debounce scroll listener
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(function() {
        scrollHintHandler();
        scrollTimeout = null;
      }, 100);
    }, { passive: true });

    // ─── Resize Handler: Update mobile state ───
    var resizeTimeoutInterlude;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeoutInterlude);
      resizeTimeoutInterlude = setTimeout(function() {
        isMobileInterlude = window.innerWidth < 768;
        if (!isMobileInterlude) {
          interludeSection.dataset.step = '2';
        }
      }, 150);
    });

  } else if (interludeSection) {
    // Fallback: show everything immediately
    interludeSection.classList.add('is-lit');
    interludeSection.classList.add('is-scrolled');
    interludeSection.dataset.step = '2';
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     SMOOTH SCROLL — For internal anchors
     ═══════════════════════════════════════════════════════════════════════════ */

  if (!prefersReducedMotion) {
    page.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     MOBILE STACK CARDS — Active state management
     ═══════════════════════════════════════════════════════════════════════════ */

  var mobileStackQuery = window.matchMedia('(max-width: 767px)');

  function initStackCards() {
    if (prefersReducedMotion || !mobileStackQuery.matches) return;

    var stacks = page.querySelectorAll('[data-stack]');

    stacks.forEach(function(stack) {
      var items = stack.querySelectorAll('[data-stack-item]');
      if (items.length === 0) return;

      var computedStyle = getComputedStyle(stack);
      var stackTopValue = computedStyle.getPropertyValue('--stack-top');
      var stackTop = parseInt(stackTopValue) || 80;

      function updateActiveStates() {
        items.forEach(function(item) {
          var rect = item.getBoundingClientRect();
          var isAtTop = rect.top <= stackTop + 5 && rect.bottom > stackTop;
          item.classList.toggle('is-active', isAtTop);
        });
      }

      var ticking = false;
      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(function() {
            updateActiveStates();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      updateActiveStates();
    });
  }

  if (mobileStackQuery.matches) {
    initStackCards();
  }

  mobileStackQuery.addEventListener('change', function(e) {
    if (e.matches) {
      initStackCards();
    }
  });

  /* ═══════════════════════════════════════════════════════════════════════════
     CARTE CADEAU — Reveal animations avec IntersectionObserver
     Effets premium : stagger reveal, parallax mobile, shimmer on hover
     ═══════════════════════════════════════════════════════════════════════════ */

  var giftcardSection = page.querySelector('[data-giftcard-section]');
  if (giftcardSection && !prefersReducedMotion && 'IntersectionObserver' in window) {
    var giftcardItems = giftcardSection.querySelectorAll('[data-giftcard-item]');

    // Observer pour révéler les cartes avec stagger
    var giftcardObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          giftcardObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -80px 0px'
    });

    giftcardItems.forEach(function(item) {
      giftcardObserver.observe(item);
    });

    // Mobile : effet parallax léger au scroll
    if (window.innerWidth < 768) {
      var giftcardParallaxHandler = function() {
        var sectionRect = giftcardSection.getBoundingClientRect();
        var sectionCenter = sectionRect.top + sectionRect.height / 2;
        var viewportCenter = window.innerHeight / 2;
        var offset = (sectionCenter - viewportCenter) / 20;

        giftcardItems.forEach(function(item, index) {
          if (item.classList.contains('is-visible')) {
            var itemOffset = offset * (1 + index * 0.15);
            item.style.transform = 'translateY(' + Math.max(-10, Math.min(10, itemOffset)) + 'px)';
          }
        });
      };

      var giftcardScrollThrottle;
      window.addEventListener('scroll', function() {
        if (!giftcardScrollThrottle) {
          giftcardScrollThrottle = requestAnimationFrame(function() {
            giftcardParallaxHandler();
            giftcardScrollThrottle = null;
          });
        }
      }, { passive: true });
    }
  } else if (giftcardSection) {
    // Reduced motion ou pas d'IntersectionObserver : afficher directement
    giftcardSection.querySelectorAll('[data-giftcard-item]').forEach(function(item) {
      item.classList.add('is-visible');
    });
  }

})();
